var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAerobicaPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.776,
    height: 20.023,
    viewBox: "0 0 14.776 20.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(-0.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(0.061 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M13.939,0a1.162,1.162,0,0,1,.846.809.827.827,0,0,1-.77,1.145,8.927,8.927,0,0,0-2.409.55A6.284,6.284,0,0,0,8.538,5c-.018.028-.032.055-.055.092a8.53,8.53,0,0,1,.681.638,9.012,9.012,0,0,1,.536.76,1.412,1.412,0,0,0,.165.211,7.851,7.851,0,0,1,1.454,1.779,4.646,4.646,0,0,1,.57,1.589,1.61,1.61,0,0,1-.055.652.782.782,0,0,1-.65.577c-1.3.248-2.608.5-3.914.734a3.349,3.349,0,0,1-.55,0,1.476,1.476,0,0,0,.065.253q1.277,2.751,2.562,5.5a1.42,1.42,0,0,1,.137,1.073,1.347,1.347,0,0,1-1.616.875,1.178,1.178,0,0,1-.66-.68L4.861,14.039c-.069-.147-.136-.295-.22-.474-.041.086-.07.147-.1.209C3.764,15.515,3.088,17.3,2.478,19.1a1.221,1.221,0,0,1-.578.8,1.192,1.192,0,0,1-1.3-.173,1.127,1.127,0,0,1-.506-1.205A19.1,19.1,0,0,1,.7,16.689a53.234,53.234,0,0,1,2.448-5.741c.434-.858.77-1.764,1.185-2.633A30.794,30.794,0,0,1,7.07,3.639a8.445,8.445,0,0,1,5.144-3.4C12.6.149,13,.1,13.4.035A.718.718,0,0,0,13.511,0ZM9.678,9.569,8.829,8.421,7.715,9.89l.039.041Z",
    transform: "translate(-0.061 0)",
    fill: "#cb3d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M178.26,64.174a1.7,1.7,0,1,1,1.71,1.7A1.706,1.706,0,0,1,178.26,64.174Z",
    transform: "translate(-168.456 -59.105)",
    fill: "#cb3d82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerobicaPerson);
export default __webpack_public_path__ + "static/media/aerobica_person.a1c9cbc67915f9ef2b461b1a1ec31122.svg";
export { ForwardRef as ReactComponent };